<template>
  <div class="files-tab-overview">
    <ChargebackFileUploadModal
      v-model="isUploadModalOpen"
      :file-type="fileType"
      @uploaded="onUploaded"
    />

    <v-card class="mb-6">
      <div class="pa-5">
        <v-row class="align-sm-center">
          <v-col cols="12" sm="8">
            <v-card-title class="pa-0">Visa RDR Files List</v-card-title>
          </v-col>
          <v-col cols="12" sm="4" class="text-center text-sm-end">
            <v-btn
              color="primary"
              class="upload-file"
              @click="isUploadModalOpen = true"
            >
              <v-icon small class="me-1">{{ icons.mdiFileExcelOutline }}</v-icon>
              <span>Upload File</span>
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-card>

    <ChargebackFilesSkeletonLoader v-if="isLoading" />

    <div v-else class="files-list">
      <v-row v-if="files.length" class="files-list">
        <v-col v-for="(file, key) in files" :key="key" cols="6" sm="4" md="3" lg="2">
          <ChargebackFile :file="file" />
        </v-col>
      </v-row>

      <v-card v-else>
        <v-card-text class="text-center">
          <p class="body-2 pa-2 ma-0">No files found.</p>
        </v-card-text>
      </v-card>

      <v-pagination
        v-if="totalCount > options.itemsPerPage"
        v-model="options.page"
        :length="Math.ceil(totalCount / options.itemsPerPage)"
        :total-visible="7"
        class="mt-6"
      />
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import { mdiFileExcelOutline } from '@mdi/js';
import useChargebackFilesList from '@/views/chargebacks/chargeback-files/useChargebackFilesList';
import ChargebackFilesSkeletonLoader
  from '@/views/chargebacks/chargeback-files/_partials/ChargebackFilesSkeletonLoader';
import { ChargebackFileTypeEnum } from '@/enums/chargeback-file-type.enum';
import ChargebackFile
  from '@/views/chargebacks/chargeback-files/_partials/ChargebackFile';
import ChargebackFileUploadModal
  from '@/views/chargebacks/chargeback-files/_partials/ChargebackFileUploadModal';

export default {
  components: { ChargebackFile, ChargebackFilesSkeletonLoader, ChargebackFileUploadModal },
  setup() {
    const {
      isLoading,
      files,
      totalCount,
      options,
      fetchFiles,
      fileType,
    } = useChargebackFilesList(ChargebackFileTypeEnum.VerifiRdr);
    const isUploadModalOpen = ref(false);

    function onUploaded() {
      if (options.value.page !== 1) {
        options.value.page = 1;

        return;
      }

      fetchFiles();
    }

    return {
      isLoading,
      files,
      totalCount,
      options,
      fileType,
      isUploadModalOpen,
      onUploaded,
      icons: {
        mdiFileExcelOutline,
      },
    };
  },
};
</script>

